import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../../lib/supabaseClient";
import "./Signup.css";

const isValidUsername = (name) => /^[a-zA-Z0-9_]{3,20}$/.test(name);

export default function SignUp() {
    const [username, setUsername] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirm, setConfirm] = useState("");
    const [msg, setMsg] = useState("");
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    const signUp = async (e) => {
        e.preventDefault();
        setMsg("");

        const u = username.trim();

        if (!isValidUsername(u)) {
            return setMsg(
                "Username must be 3–20 chars (letters, numbers, underscore).",
            );
        }
        if (!email.trim()) return setMsg("Please enter an email.");
        if (password.length < 6)
            return setMsg("Password must be at least 6 characters.");
        if (password !== confirm) return setMsg("Passwords do not match.");

        setLoading(true);

        const { data, error } = await supabase.auth.signUp({
            email: email.trim(),
            password,
            options: {
                emailRedirectTo: "https://paliapocketguide.wookrook.com/login",
                data: { username: u },
            },
        });

        if (error) {
            setLoading(false);
            return setMsg(error.message);
        }

        // If email confirmations are ON, session may be null here.
        // We can only write the profile row if the user is authenticated (policy).
        if (!data?.session?.user) {
            setLoading(false);
            setMsg(
                "Account created! Check your email to confirm, then log in to finish setting your username.",
            );

            setTimeout(() => navigate("/login"), 3000);
            return;
        }

        const userId = data.session.user.id;

        const { error: profileError } = await supabase
            .from("profiles")
            .insert([{ user_id: userId, username: u }]);

        setLoading(false);

        if (profileError) return setMsg(profileError.message);

        setMsg("Account created! You’re all set.");
        navigate("/login");
    };

    return (
        <div className="signup-container">
            <div className="signup-card">
                <h2>Create account</h2>

                <form onSubmit={signUp}>
                    <div className="signup-field">
                        <label>Username</label>
                        <input
                            type="text"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            placeholder="e.g., Wookrook"
                            autoComplete="off"
                        />
                    </div>

                    <div className="signup-field">
                        <label>Email</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="you@example.com"
                            autoComplete="email"
                        />
                    </div>

                    <div className="signup-field">
                        <label>Password</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="At least 6 characters"
                            autoComplete="new-password"
                        />
                    </div>

                    <div className="signup-field">
                        <label>Confirm password</label>
                        <input
                            type="password"
                            value={confirm}
                            onChange={(e) => setConfirm(e.target.value)}
                            placeholder="Re-type password"
                            autoComplete="new-password"
                        />
                    </div>

                    <button type="submit" disabled={loading}>
                        {loading ? "Creating..." : "Create account"}
                    </button>

                    {msg && <div className="signup-message">{msg}</div>}
                </form>

                <div className="signup-footer">
                    Already have an account? <a href="/login">Log in</a>
                </div>
            </div>
        </div>
    );
}
